<script>
import service from '@/service';
import { format, setMinutes, setHours, getHours, getMinutes } from 'date-fns';
import settings from '@/settings.js';
import numeral from 'numeral';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
	components: {
		Loading
	},
	methods: {
		showModal: function (itemId, zeljenaIzstavitevRacuna) {
			this.itemId = itemId;
			if (zeljenaIzstavitevRacuna != null) {
				let zir = new Date(zeljenaIzstavitevRacuna);
				this.uraZeljeneIzstavitveRacuna = {
					HH: numeral(getHours(zir)).format('00'),
					mm: numeral(getMinutes(zir)).format('00')
				};
				this.datumZeljeneIzstavitveRacuna = zir;
			}
			this.$refs.modal.show();
		},
		modal_okClick: function (evt) {
			evt.preventDefault();
			this.showError(null);
			this.isLoading = true;
			let datumCasZeljeneIzstavitveRacuna = null;
			if (this.datumZeljeneIzstavitveRacuna) {
				datumCasZeljeneIzstavitveRacuna = this.parseDatumInCas(this.datumZeljeneIzstavitveRacuna, this.uraZeljeneIzstavitveRacuna);
			}
			service.saveMapaZeljenaIzstavitevRacuna(this.itemId, datumCasZeljeneIzstavitveRacuna)
				.then(response => {
					if (response['message'] === 'success') {
						this.isLoading = false;
						this.$emit('success', response['zeljena_izstavitev_racuna']);
						this.$refs.modal.hide();
						setTimeout(() => {
							this.clearForm();
						}, 300);
					} else {
						this.isLoading = false;
						this.showError('Neveljaven odziv strežnika!');
						console.error('Neveljaven response message: ' + response['message']);
					}
				})
				.catch(error => {
					this.isLoading = false;
					if (error.response) {
						// Request made and server responded
						if (error.response.data.message === settings.errorMessages.serverSideValidationError) {
							this.showError('Napaka pri validaciji na strežniku!');
							console.error(error.response.data.message + ': ', error.response.data.errors);
						} else if (error.response.data.message === settings.errorMessages.notSavedError) {
							this.showError('Napaka pri shranjevanju!');
							console.error(error.response.data.message);
						} else if (error.response.data.message === settings.errorMessages.PDOException) {
							this.showError('Napaka na strežniku!');
							console.error(error.response.data.message, 'details in .ex');
						} else {
							this.showError('Neznana napaka na strežniku!');
							console.error(error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						console.log('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
		},
		modal_cancelClick: function (evt) {
			this.$refs.modal.hide();
			setTimeout(() => {
				this.clearForm();
			}, 300);
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function () {
			this.item_id = null;
			this.datumZeljeneIzstavitveRacuna = null;
			this.uraZeljeneIzstavitveRacuna.HH = '09';
			this.uraZeljeneIzstavitveRacuna.mm = '00';
			this.message.type = null;
			this.message.text = null;
		},
		click_removeDatumZeljeneIzstavitve: function () {
			this.datumZeljeneIzstavitveRacuna = null;
			this.uraZeljeneIzstavitveRacuna.HH = '09';
			this.uraZeljeneIzstavitveRacuna.mm = '00';
			this.message.type = null;
			this.message.text = null;
		},
		parseDatumInCas: function (datum, cas) {
			return format(setHours(setMinutes(datum, cas.mm), cas.HH), settings.dbDtFormat);
		}
	},
	watch: {
	},
	data: function () {
		return {
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			isLoading: false,
			itemId: null,
			datumZeljeneIzstavitveRacuna: null,
			uraZeljeneIzstavitveRacuna: {
				HH: '09',
				mm: '00'
			}
		}
	},
	computed: {
		modalTitle () {
			return 'Željena izstavitev računa';
		},
		modalCancelTitle () {
			return 'Prekliči';
		},
		modalOkTitle () {
			return 'Shrani';
		},
		message_class () {
			return 'error_message';
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" class="modal-primary" @ok="modal_okClick($event)" @cancel="modal_cancelClick($event)" :title="modalTitle" :ok-title="modalOkTitle" :cancel-title="modalCancelTitle">
		<loading :active.sync="isLoading"></loading>
		<b-form inline>
			<label class="mr-2 mb-1 mt-1">Datum: </label>
			<v-date-picker
				ref="datumZeljeneIzstavitveRacunaRef"
				:min-date="new Date(Date.now())"
				v-model="datumZeljeneIzstavitveRacuna"
				:is-required="true"
				:input-props='{
					class: "form-control",
					placeholder: "DD. MM. YYYY",
					required: true
				}'
				mode="single"
				locale="sl-SI" />
			<label class="ml-3 mr-2 mt-1 mb-1">Ura: </label>
			<v-timepicker
				ref="uraZeljeneIzstavitveRacunaRef"
				v-model="uraZeljeneIzstavitveRacuna"
				format="HH : mm"
				:hour-range="[7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]"
				hide-disabled-hours
				hide-clear-button
				:minute-interval="10"
				input-class="zeljenaIzstavitevRacunaTimepicker"/>
			<b-button class="m-1" ref="removeDatumZeljeneIzstavitveRacuna" variant="warning" @click.stop="click_removeDatumZeljeneIzstavitve()">
				<i class="fa fa-remove"></i>
			</b-button>
		</b-form>
		<b-alert :class="message_class" :variant="message.type && message.type === MESSAGE_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
	</b-modal>
</template>
<style scoped>
@import '../../../node_modules/ladda/dist/ladda-themeless.min.css';

.b_table {
	margin-bottom: o;
}
.ma_pos {
	text-align: end;
}
.noVIN {
	color: red;
}
.error_message {
	margin-top: 1rem;
	margin-bottom: 0;
}
.error_message_b {
	margin: 1rem;
}
</style>
<style>
.zeljenaIzstavitevRacunaTimepicker {
	height: 2.5em !important;
	width: 100px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Modals/ZeljenaIzstavitevRacunaModal.vue